import React from "react";
import { string } from "prop-types";

import { AdSlot } from "../../rows/ad-free";

import "./sticky-banner.m.css";

const StickyBanner = ({ pageType }) => {
  return (
    <div styleName="wrapper">
      <div styleName="banner">
        <AdSlot id={pageType === "home-page" ? "homeAndsecSticky" : "storyBottomSticky"} />
      </div>
    </div>
  );
};

StickyBanner.propTypes = {
  pageType: string,
};

export default StickyBanner;
